import React, { useRef } from 'react';
import { Modal } from 'antd';
import Draggable from 'react-draggable';

/**
 * 与 antd Modal 相同用法，可通过标题栏拖动位置。
 */
export default function DraggableModal(props) {
  const dragRef = useRef(null);
  const { modalRender: userModalRender, wrapClassName, ...rest } = props;

  const mergedModalRender = (modal) => {
    const inner = typeof userModalRender === 'function' ? userModalRender(modal) : modal;
    return (
      <Draggable handle=".ant-modal-header" nodeRef={dragRef}>
        <div ref={dragRef}>{inner}</div>
      </Draggable>
    );
  };

  const cls = wrapClassName ? `draggable-modal-root ${wrapClassName}` : 'draggable-modal-root';

  return <Modal {...rest} wrapClassName={cls} modalRender={mergedModalRender} />;
}
